<template>
  <compare-tool
    ref="compareTool"
    :selectedComponent="selectedComponent"
    :chartTabContent="chartTabContent"
    :chartData="chartData"
    :tooltipData="tooltipData"
    :tooltipDataProp="tooltipDataProp"
    :chartProperties="chartProperties"
    :compareGraphProp="compareGraphProp"
    :compareGraphOwners="compareGraphOwners"
    :compareGraphOption="compareGraphOption"
    :projectionYear="projectionYear"
    :tooltipHeader="tooltipHeader"
    :pageHeadingInfo="pageHeadingInfo"
    :headers="headersdata"
    :rowsdata="rowsdata"
    :groupedRows="grouprow"
    :mainHeading="mainHeading"
    @onChangeChartTab="onChangeChartTab"
    @onBack="onBack"
    @submit="applyFilter"
    @changeGraphPropOption="changeGraphPropOption"
  ></compare-tool>
</template>
<script>
import { InvestmentEngagementTool } from "../../mixin";
import { CompareTool } from "../../component/tool";

//import { CommonHelper } from "../../helpers";
import {
  AdvanceInvestmentFilter,
  RepaymentOptionList,
} from "../../helpers/constant";

import { ICEInvestmentIntegration } from "../../mixin";

import {
  GET_COMPARE_INVESTMENTS_INFO,
  SET_COMPARE_INVESTMENTS_INFO,
  SET_LOADER_VISIBILITY,
  GET_RISK_PROFILE_DATA,
} from "../../helpers/vuex-constants";
import { CommonHelper } from "../../helpers";
import { mapActions, mapGetters } from "vuex";
import InvestmentProjection from "../../models/investmentProjection";
import CompareGraph from "../../models/compareGraph";
export default {
  components: { CompareTool },
  computed: {
    ...mapGetters("investment", {
      getCompareInvestmentsInfo: GET_COMPARE_INVESTMENTS_INFO,
    }),
    ...mapGetters({
      getRiskProfileData: GET_RISK_PROFILE_DATA,
    }),
    parentContainerWidth() {
      return this.$refs.compareTool.getScreenWidth();
    },
  },
  async mounted() {
    this.chartProperties = CompareGraph.getChartProperties();

    this.getScreenWidth();
    await this.getProjectionData(0);
    this.compareModel();
  },
  data() {
    return {
      projectionDetails: [],
      compareGraphOwners: [],
      mainHeading: "Table Comparison",
      selectedComponent: "chart-line-group",
      selectedtabId: "balanceGraph",
      startingYear: 0,
      chartData: [],
      rootWidth: 0,
      headersdata: [],
      rowsdata: {},
      tooltipHeader: [],
      chartProperties: {},
      tooltipData: [],
      tooltipDataProp: [],
      xAxisArray: [],
      xAxisMinValue: 0,
      lineAxisArray: [],
      projectionResult: {},
      chartTabContent: [
        {
          text: "Balance",
          id: "balanceGraph",
          active: true,
        },
        {
          text: "Transaction",
          id: "contributionWithdrawalGraph",
          active: false,
        },
        {
          text: "Return",
          id: "ReturnFeesGraph",
          active: false,
        },
      ],
      toolTipPropMapping: {
        balanceGraph: [{ id: "Balance", prop: "closingBalance" }],
        contributionWithdrawalGraph: [
          { id: "Balance", prop: "closingBalance", type: "contribution" },
        ],
        ReturnFeesGraph: [{ id: "Balance", prop: "closingBalance" }],
      },
      barColors: ["#005ba1", "#a50032", "#f5c400", "#00af41", "#00a8e1"],
      pageHeadingInfo: {
        heading: "Compare different investment instances",
        subHeading:
          "You can use the information to decide on strategies for a desired outcome",
      },
      investmentInstance: [],
      compareGraphProp: "",
      compareGraphOption: [],
      contentInfo: {},
      grouprow: [
        {
          heading: "Key Details",
          expanded: true,
          visible: true,
          groupid: "groupid1",
          columns: [
            {
              text: "Initial Balance",
              name: "InitialBalance",
              type: "String",
              style: {
                width: "230px",
              },
            },
            {
              text: "Risk Profile",
              name: "riskProfile",
              type: "String",
              style: {
                width: "230px",
              },
            },
            {
              text: "Growth",
              name: "growth",
              type: "String",
              style: {
                width: "230px",
              },
            },
            {
              text: "Income",
              name: "income",
              type: "String",
              style: {
                width: "230px",
              },
            },
            {
              text: "Franking",
              name: "franking",
              type: "String",
              style: {
                width: "230px",
              },
            },
            {
              text: "Contribution",
              name: "contribution",
              type: "String",
              style: {
                width: "230px",
              },
            },
            {
              text: "Contribution Frequency",
              name: "contributionFrequency",
              type: "String",
              style: {
                width: "230px",
              },
            },
            {
              text: "Dividend Reinvestment",
              name: "dividentreimbursment",
              type: "String",
              style: {
                width: "230px",
              },
            },
          ],
        },
        {
          heading: "Additional",
          expanded: true,
          visible: true,
          groupid: "groupid2",
          style: {
            width: "230px",
          },

          columns: [
            {
              visible: true,
              text: "Return",
              name: "Return",
              type: "DataList",
              style: {
                width: "230px",
              },
            },
            {
              visible: true,
              text: "Contribution",
              name: "Contribution",
              type: "DataList",
              style: {
                width: "230px",
              },
            },
            {
              visible: true,
              text: "Withdrawal",
              name: "Withdrawal",
              type: "DataList",
              style: {
                width: "230px",
              },
            },
            {
              visible: true,
              text: "Market Crash",
              name: "MarketCrash",
              type: "DataList",
              style: {
                width: "230px",
              },
            },
            // {
            //   text: "Baseline Interest Rate",
            //   name: "BaselineInterestRate",
            //   type: "String",
            // },
          ],
        },
      ],
    };
  },

  beforeDestroy() {
    this.setCompareInvestmentsInfo([]);
  },
  mixins: [InvestmentEngagementTool, ICEInvestmentIntegration],
  methods: {
    ...mapActions({
      setLoaderVisibility: SET_LOADER_VISIBILITY,
    }),
    ...mapActions("investment", {
      setCompareInvestmentsInfo: SET_COMPARE_INVESTMENTS_INFO,
    }),
    changeGraphPropOption(option) {
      this.chartData = [];
      this.compareGraphProp = option.name;
      this.refreshChart(option);
    },
    compareModel() {
      let data = this.getCompareInvestmentsInfo;
      let Headers = [];
      let AdditionalRowVisible = false;
      let rows = {
        groupid1: {},
        groupid2: {},
        // groupid3: []
      };

      Headers.push({
        text: "Include in Holistic",
        fieldName: "heading",
        switchRequied: false,
        style: {
          width: "230px",
        },
      });
      for (let i = 0; i < 5; i++) {
        if (i <= data.length - 1) {
          let riskProfile = this.getRiskProfileData.data.filter(
            (x) => x.profileId == data[i].riskProfileId
          );
          let defaultRiskProfile = this.getRiskProfileData.data.filter(
            (x) => x.profileId == 0
          );
          rows["groupid1"][data[i].investmentGuid.toString()] = {
            InitialBalance: CommonHelper.convertIntoCurrencyWithoutDecimal(
              data[i].amount
            ),
            riskProfile:
              riskProfile.length > 0
                ? riskProfile[0].profileName
                : defaultRiskProfile[i].profileName,
            growth:
              CommonHelper.convertAmountIntoDecimalFormat(data[i].growthRate) +
              "%",
            income:
              CommonHelper.convertAmountIntoDecimalFormat(data[i].incomeRate) +
              "%",
            franking:
              CommonHelper.convertAmountIntoDecimalFormat(
                data[i].frankingRate
              ) + "%",
            contribution: CommonHelper.convertIntoCurrencyWithoutDecimal(
              data[i].contributionAmount
            ),
            contributionFrequency: RepaymentOptionList.filter(
              (x) => x.value == data[i].durationTypeId
            )[0].text,
            dividentreimbursment: data[i].isDRP ? "Yes" : "No",
          };
          let additionalData = [];
          if (data[i].advancedetails != null) {
            additionalData = data[i].advancedetails
              .filter((sr) => sr.typeId != AdvanceInvestmentFilter.Maturity)
              .map((r) => {
                let p = {
                  label: null,
                  typeId: null,
                  data: [],
                };

                let startMonth =
                  !r.startDate || r.startDate == ""
                    ? r.startDate
                    : CommonHelper.getMonthName(
                        CommonHelper.getMonthfromMonthYear(r.startDate)
                      );
                let startYear =
                  !r.startDate || r.startDate == ""
                    ? r.startDate
                    : CommonHelper.getYearfromMonthYear(r.startDate);
                let endMonth =
                  !r.endDate || r.endDate == ""
                    ? r.endDate
                    : CommonHelper.getMonthName(
                        CommonHelper.getMonthfromMonthYear(r.endDate)
                      );
                let endYear =
                  !r.endDate || r.endDate == ""
                    ? r.endDate
                    : CommonHelper.getYearfromMonthYear(r.endDate);
                p.typeId = r.typeId;
                if (r.description == undefined || r.description != "") {
                  p.label = r.description;
                } else {
                  p.label = this.DescriptionAdditionalForm(
                    r.descriptionplaceholder,
                    r.typeId
                  );
                }
                if (r.typeId == 1) {
                  p.data[0] = `Income ${CommonHelper.convertAmountIntoDecimalFormat(
                    r.amount
                  )}% Growth ${CommonHelper.convertAmountIntoDecimalFormat(
                    r.amount1
                  )}% Franking ${CommonHelper.convertAmountIntoDecimalFormat(
                    r.amount2
                  )}%`;
                } else if (r.typeId == 2 || r.typeId == 3) {
                  p.data[0] = `${CommonHelper.convertIntoCurrencyWithoutDecimal(
                    r.amount
                  )}`;
                } else if (r.typeId == 5) {
                  p.data[0] = r.amount + "%";
                }
                if (r.typeId != 4) {
                  p.data[1] = `${startMonth}
            ${startYear} ${endMonth ? "-" : ""} ${endMonth}
            ${endYear}`;
                }
                return p;
              });
          }
          if (!AdditionalRowVisible) {
            AdditionalRowVisible = additionalData.length > 0;
          }
          rows["groupid2"][data[i].investmentGuid.toString()] = {
            Return: {
              listdata: additionalData.filter(
                (x) => x.typeId == AdvanceInvestmentFilter.Return
              ),
            },
            Contribution: {
              listdata: additionalData.filter(
                (x) => x.typeId == AdvanceInvestmentFilter.Contribution
              ),
            },
            Withdrawal: {
              listdata: additionalData.filter(
                (x) => x.typeId == AdvanceInvestmentFilter.Withdrawal
              ),
            },
            Fee: {
              listdata: additionalData.filter(
                (x) => x.typeId == AdvanceInvestmentFilter.Fee
              ),
            },
            MarketCrash: {
              listdata: additionalData.filter(
                (x) => x.typeId == AdvanceInvestmentFilter.MarketCrash
              ),
            },
            //  BaselineInterestRate: data[i].interestRate + "%",
          };

          Headers.push({
            text: data[i].description,
            fieldName: data[i].investmentGuid.toString(),
            switchRequied: true,
            colour: this.barColors[i],
          });
        } else {
          rows["groupid1"]["blank" + i] = {
            InitialBalance: "",
            riskProfile: "",
            growth: "",
            income: "",
            franking: "",
            contribution: "",
            contributionFrequency: "",
            dividentreimbursment: "",
          };

          //AdditionalRowVisible = false;
          rows["groupid2"]["blank" + i] = {
            Return: {
              listdata: [],
            },
            Contribution: {
              listdata: [],
            },
            Withdrawal: {
              listdata: [],
            },
            MarketCrash: {
              listdata: [],
            },
            //  BaselineInterestRate: data[i].interestRate + "%",
          };

          Headers.push({
            text: "",
            fieldName: "blank" + i,
            switchRequied: true,
            colour: this.barColors[i],
          });
        }
      }

      this.headersdata = Headers;
      this.rowsdata = rows;
      this.grouprow.filter((x) => x.groupid == "groupid2")[0].visible =
        AdditionalRowVisible;
    },
    getcompareGraphOption(tabId) {
      let compareOptionModel = {
        balanceGraph: [
          {
            id: "closingBalance",
            name: "",
            toolTipPro: [
              { id: "closingBalance", name: "Balance", isCurrencyType: true },
              {
                name: "Income (Cumulative)",
                id: "incomeReturnCumulative",
                isCurrencyType: true,
              },
              {
                name: "Growth (Cumulative)",
                id: "growthReturnCumulative",
                isCurrencyType: true,
              },
              {
                name: "Income & Growth (Cumulative)",
                id: "incomeGrowthReturnCumulative",
                isCurrencyType: true,
              },
            ],
          },
        ],

        contributionWithdrawalGraph: [
          {
            id: "contributionsAll",
            name: "Contributions",
            toolTipPro: [
              {
                id: "contributionsAll",
                name: "Contributions",
                isCurrencyType: true,
              },
              {
                id: "contributionsAllCumulative",
                name: "Contributions (Cumulative)",
                isCurrencyType: true,
              },
            ],
          },
          {
            id: "withdrawalsAll",
            name: "Withdrawals",
            toolTipPro: [
              {
                id: "withdrawalsAll",
                name: "Withdrawals",
                isCurrencyType: true,
              },
              {
                id: "withdrawalsAllCumulative",
                name: "Withdrawals (Cumulative)",
                isCurrencyType: true,
              },
            ],
          },
        ],

        ReturnFeesGraph: [
          {
            id: "incomeGrowthFees",
            name: "Income & Growth (Ex Fees) ",
            toolTipPro: [
              {
                id: "incomeGrowthFees",
                name: "Income & Growth (Ex Fees)",
                isCurrencyType: true,
              },

              {
                name: "Income",
                id: "incomeReturn",
                isCurrencyType: true,
              },
              {
                name: "Growth",
                id: "growthReturn",
                isCurrencyType: true,
              },
              {
                name: "Income & Growth (Ex Fees) (Cumulative)",
                id: "incomeGrowthReturnCumulative",
                isCurrencyType: true,
              },
              {
                name: "Income (Cumulative)",
                id: "incomeReturnCumulative",
                isCurrencyType: true,
              },
              {
                name: "Growth (Cumulative)",
                id: "growthReturnCumulative",
                isCurrencyType: true,
              },
            ],
          },
          {
            id: "incomeGrowthNetFees",
            name: "Income & Growth (Net of Fees)",
            toolTipPro: [
              {
                id: "incomeGrowthNetFees",
                name: "Income & Growth (Net)",
                isCurrencyType: true,
              },
              {
                name: "Income",
                id: "incomeReturn",
                isCurrencyType: true,
              },
              {
                name: "Growth",
                id: "growthReturn",
                isCurrencyType: true,
              },
              {
                name: "Fees",
                id: "fees",
                isCurrencyType: true,
              },
            ],
          },
          {
            id: "incomeReturn",
            name: "Income",
            toolTipPro: [
              {
                id: "incomeReturn",
                name: "Income",
                isCurrencyType: true,
              },
              {
                name: "Income (Cumulative)",
                id: "incomeReturnCumulative",
                isCurrencyType: true,
              },
            ],
          },
          {
            id: "growthReturn",
            name: "Growth",
            toolTipPro: [
              {
                id: "growthReturn",
                name: "Growth",
                isCurrencyType: true,
              },
              {
                name: "Growth (Cumulative)",
                id: "growthReturnCumulative",
                isCurrencyType: true,
              },
            ],
          },
          {
            id: "fees",
            name: "Fees",
            toolTipPro: [
              { id: "fees", name: "Total Fees", isCurrencyType: true },
              {
                id: "platformFees",
                name: "Platform Fees",
                isCurrencyType: true,
              },
              { id: "adviceFees", name: "Advice Fees", isCurrencyType: true },
              { id: "otherFees", name: "Other Fees", isCurrencyType: true },
            ],
          },
        ],
      };
      return compareOptionModel[tabId];
    },

    async applyFilter() {
      this.chartData = [];
      if (this.projectionYear.Value > 0) {
        this.tooltipHeader = [];
        this.tooltipData = [];
        this.linetooltipData = [];
        this.xAxisArray = [];
        this.lineAxisArray = [];

        await this.getProjectionData(this.projectionYear.Value);
      }
    },
    async getProjectionData(projectionYear) {
      this.investmentInstance =
        this.ConvertInvestmentsToProjectionModel(projectionYear);
      let projectionApiPayload = this.prepareAPIModel(this.investmentInstance);
      this.setLoaderVisibility(true);
      const apiResponse = await this.getProjection(projectionApiPayload);
      this.projectionResult =
        InvestmentProjection.setInvestmentProjections(apiResponse);
      this.setLoaderVisibility(false);
      this.startingYear =
        this.projectionResult.investmentProjectionResult[0].investmentProjection[0].year;
      this.xAxisMinValue = this.startingYear;
      this.onChangeChartTab(this.selectedtabId);
    },
    getScreenWidth() {
      this.rootWidth =
        this.parentContainerWidth -
        (this.chartProperties.axisRightWidth +
          this.chartProperties.axisRightWidth);
    },
    onChangeChartTab(tabId) {
      this.chartData = [];
      this.selectedTabComponent = tabId;
      this.compareGraphOption = this.getcompareGraphOption(
        this.selectedTabComponent
      );
      this.compareGraphProp = this.compareGraphOption[0].name;
      this.refreshChart(this.compareGraphOption[0]);
    },

    refreshChart(selectedOption) {
      let graphModel = {};
      let width = 0;
      let isIncludeStartingPoint = 0;
      if (this.selectedTabComponent == "balanceGraph") {
        this.compareGraphOption = [];
        this.compareGraphProp = "Balance";
        this.selectedComponent = "chart-line-group";
        graphModel = CompareGraph.initializeLineGraphWithDefaultValue(
          this.startingYear,
          this.startingYear + this.projectionYear.Value
        );
        width = this.rootWidth;
        isIncludeStartingPoint = true;
      } else {
        this.selectedComponent = "chart-bar-group";
        graphModel = CompareGraph.initializeBarGraphWithDefaultValue(
          this.startingYear,
          this.startingYear + this.projectionYear.Value
        );
        width =
          (this.projectionResult.investmentProjectionResult.length + 1) *
          18 *
          this.projectionYear.Value;
        if (width < this.rootWidth) {
          width = this.rootWidth;
        }
        isIncludeStartingPoint = false;
      }
      this.refreshChartData(
        selectedOption,
        graphModel,
        width,
        isIncludeStartingPoint
      );
    },

    refreshChartData(option, graphModel, width, isIncludeStartingPoint) {
      let toolTipBoxWidth = (this.investmentInstance.length + 1) * 135;

      this.tooltipDataProp = CompareGraph.getChartToolTipPro(option);

      CompareGraph.fillGraphModel(
        graphModel,
        this.projectionResult.investmentProjectionResult,
        "investmentProjection",
        option.id,
        "openingBalance",
        option.toolTipPro,
        isIncludeStartingPoint
      );
      let graphPros = CompareGraph.getGraphLegends(
        this.projectionResult.investmentProjectionResult,
        this.investmentInstance,
        "investmentID",
        this.barColors,
        this.startingYear
      );
      this.chartData = graphModel.data;
      this.tooltipData = graphModel.toolTipData;
      this.tooltipHeader = graphPros.charttooltipHeader;
      this.chartProperties = CompareGraph.getChartProperties(
        graphModel.maxYAxis,
        graphPros.chartLegendColors,
        graphPros.chartLegends,
        width,
        graphModel.domainX,
        toolTipBoxWidth,
        this.compareGraphProp,
        graphModel.minYAxis
      );
    },

    ConvertInvestmentsToProjectionModel(projectionYear) {
      let totalInvestment = this.getCompareInvestmentsInfo.length;
      let projectionsData = [];
      for (let i = 0; i < totalInvestment; i++) {
        let projection = {};
        if (
          projectionYear == 0 &&
          this.projectionYear.Value <
            this.getCompareInvestmentsInfo[i].projectionYear
        ) {
          this.projectionYear.Value =
            this.getCompareInvestmentsInfo[i].projectionYear;
        }
        projection.ownerEntityType =
          this.getCompareInvestmentsInfo[i].ownerEntityType;
        projection.investmentClassID =
          this.getCompareInvestmentsInfo[i].investmentClassID;
        projection.amount = this.getCompareInvestmentsInfo[i].amount;
        projection.riskProfileId =
          this.getCompareInvestmentsInfo[i].riskProfileId;
        projection.incomeRate = this.getCompareInvestmentsInfo[i].incomeRate;
        projection.growthRate = this.getCompareInvestmentsInfo[i].growthRate;
        projection.frankingRate =
          this.getCompareInvestmentsInfo[i].frankingRate;
        projection.contributionAmount =
          this.getCompareInvestmentsInfo[i].contributionAmount;
        projection.durationTypeId =
          this.getCompareInvestmentsInfo[i].durationTypeId;
        projection.isDRP = this.getCompareInvestmentsInfo[i].isDRP ? 1 : 0;
        projection.description = this.getCompareInvestmentsInfo[i].description;
        projection.uniqueId = CommonHelper.uuidv4();
        projection.advancedetails = this.getAdvanceFilterDetails(
          this.getCompareInvestmentsInfo[i].advancedetails
        );
        projectionsData.push(projection);
      }
      return projectionsData;
    },
    onBack() {
      this.$router.push({ name: "investment-instance-selection" });
    },
  },
};
</script>
<style lang="scss" module></style>
